<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button type="primary" size="small" @click="getList">刷新</el-button>
        </li>
        <li>
          <span>开始日期：</span>
          <el-date-picker v-model="startDay" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyyMMdd" :clearable="false" @change="myOption.restStartPage();getList();"></el-date-picker>
        </li>
        <li>
          <span>结束日期：</span>
          <el-date-picker v-model="endDay" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyyMMdd" :clearable="false" @change="myOption.restStartPage();getList();"></el-date-picker>
        </li>
        <li>
          <span>REQUEST_ID：</span>
          <el-input size="small" v-model="requestId" @input="getList"></el-input>
        </li>
        <li>
          <span>IMEI：</span>
          <el-input size="small" v-model="imei" @input="getList"></el-input>
        </li>
        <li>
          <span>IMEI_MD5：</span>
          <el-input size="small" v-model="imeiMd5" @input="getList"></el-input>
        </li>
        <li>
          <span>OAID：</span>
          <el-input size="small" v-model="oaid" @input="getList"></el-input>
        </li>
        <li>
          <span>ANDROID_ID：</span>
          <el-input size="small" v-model="androidId" @input="getList"></el-input>
        </li>
        <li>
          <span>ANDROID_ID_MD5：</span>
          <el-input size="small" v-model="androidIdMd5" @input="getList"></el-input>
        </li>
        <li>
          <span>代码位ID：</span>
          <el-input size="small" v-model="slotId" @input="getList"></el-input>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="__time__" label="时间" min-width="180px" fixed="left"></el-table-column>
        <el-table-column prop="request_id" label="REQUEST_ID" min-width="300px"></el-table-column>
        <el-table-column prop="imei" label="IMEI" min-width="200px"></el-table-column>
        <el-table-column prop="imei_md5" label="IMEI_MD5" min-width="200px"></el-table-column>
        <el-table-column prop="oaid" label="OAID" min-width="200px"></el-table-column>
        <el-table-column prop="android_id" label="ANDROID_ID" min-width="200px"></el-table-column>
        <el-table-column prop="android_id_md5" label="ANDROID_ID_MD5" min-width="200px"></el-table-column>
        <el-table-column prop="slot_id" label="代码位ID" min-width="200px"></el-table-column>
        <el-table-column label="请求内容" min-width="120px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="setDialogValue(tableData[scope.$index].json)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="请求内容" :visible.sync="dialog" width="80%">
        <span v-html="dialogValue"></span>
      </el-dialog>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'Request',
  components: {
    Pagination
  },
  data () {
    return {
      dialog: false,
      dialogValue: '',
      isLoading: false,
      thisModule: [],
      tableData: [],
      startDay: this.myOption.getNowDateYMD(),
      endDay: this.myOption.getNowDateYMD(),
      requestId: '',
      imei: '',
      imeiMd5: '',
      androidId: '',
      androidIdMd5: '',
      slotId: '',
      oaid: ''
    }
  },
  created () {
    // 缓存模块配置
    this.thisModule = this.myOption.requestModule.logStream.children.request
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.api,
        data: this.qs.stringify({
          from: this.myOption.getNowDateStamp(this.startDay, true),
          to: this.myOption.getNowDateStamp(this.endDay, false),
          offset: (this.$store.state.user.currentPage - 1) * this.$store.state.user.pageSize,
          lines: this.$store.state.user.pageSize,
          reverse: true,
          request_id: this.requestId,
          imei: this.imei,
          imei_md5: this.imeiMd5,
          android_id: this.androidId,
          android_id_md5: this.androidIdMd5,
          slot_id: this.slotId,
          oaid: this.oaid
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.logs || []
          for (let val of data) {
            val.__time__ = this.myOption.writeCurrentDate(val.__time__)
            val.json = this.myOption.getJsonData(val.json)
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.count)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 查看请求内容
    setDialogValue (value) {
      this.dialogValue = value
      this.dialog = true
    }
  }
}
</script>

<style scoped>
  .List-headr li {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/log_stream/Request.vue